import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  _retry?: boolean;
}

const apiClient = axios.create();
axios.defaults.withCredentials = true;

let isRefreshing = false;
let subscribers: Array<(token: string) => void> = [];

const onRefreshed = (token: string) => {
  subscribers.forEach((callback) => callback(token));
  subscribers = [];
};

const addSubscriber = (callback: (token: string) => void) => {
  subscribers.push(callback);
};

apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  async (error: AxiosError) => {
    const originalRequest = error.config as CustomAxiosRequestConfig;

    if (
      error.response?.status === 500 &&
      (error.response?.data?.message === 'jwt expired' ||
        error.response?.data?.message === 'jwt must be provided') &&
      !originalRequest._retry
    ) {
      if (isRefreshing) {
        return new Promise((resolve) => {
          addSubscriber((token: string) => {
            originalRequest.headers['Authorization'] = `Bearer ${token}`;
            resolve(apiClient(originalRequest));
          });
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const response = await axios.get(
          `${process.env.GATSBY_SSO_BACKEND_API_URL}/auth/refresh`
        );

        const newToken = response.data.token;

        onRefreshed(newToken);

        originalRequest.headers['Authorization'] = `Bearer ${newToken}`;

        return apiClient(originalRequest);
      } catch (refreshError) {
        window.location.href = `${process.env.GATSBY_SSO_REDIRECT_URI}`;
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
